<template>
    <Modal size="md" @close="close">
        <div class="text-center text-sm p-5 px-4 sm:px-16">
            <div
                class="TopIconModal rounded-full border-purple-500 text-purple-500 text-4xl border-4"
            >
                <i class="fa fa-plus"></i>
            </div>

            <h2 class="font-normal my-6">
                Inviter ambassadør
            </h2>
            <p class="my-6 text-gray-600 text-base font-thin">
                Inviter influenter til dit ambassadør-team ved at kopiere og dele nedenstående link.
                Influenten vil blive bedt om at oprette en profil på betterhype.
            </p>

            <label class="block text-left font-medium">Inviter via link</label>
            <TextCopy class="m-b-lg">
                <template v-slot:default="{ copy, icon }">
                    <div class="input-group input-group-lg">
                        <input type="text" class="form-control" :value="invitationLink" readonly />
                        <div class="input-group-btn">
                            <button class="btn btn-success" @click="copy(invitationLink)">
                                <i class="fa" :class="icon"></i>
                            </button>
                        </div>
                    </div>
                </template>
            </TextCopy>

            <button class="btn btn-primary p-4 px-8" @click="finished">
                Færdig
            </button>
        </div>
    </Modal>
</template>

<style lang="less" type="text/less"></style>

<script type="text/babel">
import Modal from 'dashboard-js/components/Modal'
import TextCopy from 'dashboard-js/components/utilities/TextCopy'

export default {
    components: { Modal, TextCopy },

    props: ['invitationLink'],

    methods: {
        close() {
            this.$emit('close')
        },

        finished() {
            this.close()
        },
    },
}
</script>
